import { render, staticRenderFns } from "./OcrFileUpload.vue?vue&type=template&id=329a4ba2&scoped=true&"
import script from "./OcrFileUpload.vue?vue&type=script&lang=js&"
export * from "./OcrFileUpload.vue?vue&type=script&lang=js&"
import style0 from "./OcrFileUpload.vue?vue&type=style&index=0&id=329a4ba2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a4ba2",
  null
  
)

export default component.exports